import * as yup from 'yup';

import { HorizontalRightsizingFormModel } from '../_types';

export const hpaV1ValidationSchema = yup.object({
  enabled: yup.boolean().required('Enabled is required'),
  pods: yup
    .object({
      min: yup
        .number()
        .required('Required')
        .min(0, 'should be a non-negative value')
        .test((min, context) => {
          const max = context.resolve(yup.ref('max'));
          if (typeof min === 'number' && typeof max === 'number' && min > max) {
            return context.createError({
              message: 'min higher than max value',
            });
          }
          return true;
        }),
      max: yup
        .number()
        .required('Required')
        .min(0, 'should be a non-negative value'),
    })
    .when('enabled', {
      is: (enabled: boolean) => !enabled,
      then: (schema) =>
        schema.shape({
          min: yup.number().nullable().notRequired(),
          max: yup.number().nullable().notRequired(),
        }),
    }),
}) satisfies yup.ObjectSchema<HorizontalRightsizingFormModel>;
